"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountTemplateError = void 0;
exports.parseAccountTemplate = parseAccountTemplate;
const ACCOUNT_CLASSES = [
    'asset',
    'liability',
    'equity',
    'revenue',
    'cogs',
    'expense',
    'other',
];
const NORMAL_BALANCES = ['debit', 'credit', 'mixed'];
const STATEMENTS = ['BS', 'PL'];
const SUBLEDGERS = [
    'customer',
    'supplier',
    'cashbox',
    'bank_or_wallet',
    'inventory',
    'fixed_asset',
    'tax',
    'employee',
];
class AccountTemplateError extends Error {
    constructor(code, field, value) {
        super('invalid chart template value for ' + code + '.' + field + ': ' + String(value));
        this.name = 'AccountTemplateError';
    }
}
exports.AccountTemplateError = AccountTemplateError;
function toBoolean(value, code, field) {
    if (typeof value === 'boolean')
        return value;
    if (value === 'True' || value === 'true')
        return true;
    if (value === 'False' || value === 'false' || value === '' || value === undefined)
        return false;
    throw new AccountTemplateError(code, field, value);
}
/** يحوّل سجلات القالب إلى حسابات مع تحقق صريح من كل قيمة مُعدّدة. */
function parseAccountTemplate(records) {
    return records.map((record) => {
        const code = record.code;
        if (!ACCOUNT_CLASSES.includes(record.account_class)) {
            throw new AccountTemplateError(code, 'account_class', record.account_class);
        }
        if (!NORMAL_BALANCES.includes(record.normal_balance)) {
            throw new AccountTemplateError(code, 'normal_balance', record.normal_balance);
        }
        if (!STATEMENTS.includes(record.statement)) {
            throw new AccountTemplateError(code, 'statement', record.statement);
        }
        const subledgerRaw = record.subledger ?? '';
        if (subledgerRaw !== '' && !SUBLEDGERS.includes(subledgerRaw)) {
            throw new AccountTemplateError(code, 'subledger', subledgerRaw);
        }
        return {
            code,
            parentCode: record.parent_code === '' ? null : record.parent_code,
            nameAr: record.name_ar,
            nameEn: record.name_en ?? null,
            accountClass: record.account_class,
            normalBalance: record.normal_balance,
            statement: record.statement,
            subledger: subledgerRaw === '' ? null : subledgerRaw,
            isPostable: toBoolean(record.is_postable, code, 'is_postable'),
            isSystem: toBoolean(record.is_system, code, 'is_system'),
            status: record.status,
        };
    });
}
//# sourceMappingURL=template.js.map